import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { OwnerService } from '../../../service/owner/owner.service';
import { CaseService } from '../../../service/case/case.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'wa9212',
  templateUrl: 'wa9212.component.html',
  styleUrls: ['wa9212.component.scss']
})
export class Wa9212Component implements OnInit {
  public componentTitle = 'WA9212:ケースマスタ登録';

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  // for error message
  public validation = validation;
  // Define each input element (initial value and validation rule)
  public caseCd: FormControl;
  public caseTx: FormControl;
  // build FormGroup

  private errorInfo = '';

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  private isSubmitButtonEnabled = false;

  readonly STRINGS_ACTIVE = 'active';
  readonly STRINGS_ERROR = 'error';

  private caseCdCls = '';
  private caseTxCls = '';
  private delisizeNrCls = '';

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private ownerService: OwnerService,
    private caseService: CaseService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {

    this.caseCd = new FormControl('', [
      Validators.pattern(validation.halfBlankOnly),
      Validators.pattern(validation.code39),
      Validators.maxLength(validation.caseCd.maxLength)
    ]);
    this.caseTx = new FormControl('', [
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.caseTx.maxLength)]);
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngOnInit() {
    setTimeout(() => {
      // this.caseCdElement.nativeElement.focus();
      this.onView();
    }, 500);
  }

  onView() { }

  onSubmit() {
    this.errorInfo = '';
    if (!this.isSubmitButtonEnabled)
      return;

    var caseCd = this.caseCd.value.trim();
    var caseTx = this.caseTx.value.trim();
    let errors = false;
    if (this.caseCd.errors !== null) {
      this.caseCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.caseTx.errors !== null) {
      this.caseTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.caseService
      .post(caseCd, caseTx, 'wa9212')
      .then(outputJson => {
        this.working = false;
        if (outputJson.count === 1) {
          sessionStorage.setItem('SuccessInfoMessage', '登録が完了しました');
        }
        this.closeButtonClick.emit(true);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  cancel() {
    this.errorInfo = '';

    this.closeButtonClick.emit(false);
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();
    }
    else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  initDatas() {
    this.caseCd.setValue('');
    this.caseTx.setValue('');
    this.isSubmitButtonEnabled = false;
  }

  ngDoCheck() {
    if (!this.isShow)
      return;

    this.caseCdCls = this.caseCd.value === '' ? '' : (this.caseCd.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.caseTxCls = this.caseTx.value === '' ? '' : (this.caseTx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.checkSubmitButtonState();
  }

  checkSubmitButtonState() {
    this.isSubmitButtonEnabled = this.caseCdCls === this.STRINGS_ACTIVE &&
      this.caseTxCls === this.STRINGS_ACTIVE;
  }

  clrErr() {
    this.errorInfo = '';
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9212/wa9212.component.ts